import UnionRightRail from '@xo-union/tk-component-right-rail';
import React from 'react';

import styles from './index.scss';

export * from './components';

interface Props {
  open: boolean;
  children: any;
  overlay?: boolean;
  className?: string;
  style?: any;
  onEscapeKey?: () => void;
}

const RightRail: React.FC<Props> = ({ open, children, overlay = true, className = '', onEscapeKey }) => {
  const classNames = [styles.railContainer, className, styles[open ? 'open' : 'close']];

  return (
    <UnionRightRail className={classNames.join(' ')} visible={open} overlay={overlay} onEscapeKey={onEscapeKey}>
      {open && children}
    </UnionRightRail>
  );
};

export default RightRail;
